export default "<p>form-template-date-field-config works!</p>\r\n"